import { BeGrid, BeWindow } from "@beos-css/react/index.ts";

const stockContent: React.CSSProperties = { width: 320, height: 200 };

export function WindowDecorDemo() {
	return (
		<section id="demo-window-decor">
			<h2>Window decor (B_TITLED_WINDOW_LOOK)</h2>
			<p>
				The yellow tab shows close + zoom (normal), close-only, or no buttons (dialogs) depending on the handlers passed. An <em>active</em>{" "}
				window's buttons are always live -- only the grey <code>inactive</code> palette marks a window behind the front one.
			</p>
			<BeGrid min={23} align="start" gap="row">
				<BeWindow title="Untitled" onClose={() => {}} onZoom={() => {}} contentStyle={stockContent}>
					A focused titled window with both close and zoom buttons.
				</BeWindow>

				<BeWindow inactive title="Inactive window" onClose={() => {}} onZoom={() => {}} contentStyle={stockContent}>
					Unfocused: grey palette + softer drop shadow.
				</BeWindow>

				<BeWindow title="Close only" onClose={() => {}} contentStyle={{ width: 240, height: 120 }}>
					A close-only tab (no zoom button).
				</BeWindow>

				<BeWindow title="Dialog" contentStyle={{ width: 240, height: 120 }}>
					A button-less tab. NOT B_MODAL_WINDOW_LOOK -- that one has no title bar at all (see Window looks below); this is still a titled
					window, just with no gadgets passed.
				</BeWindow>
			</BeGrid>
		</section>
	);
}
